import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    '[style.width]': 'hostWidth()',
  },
})
export class ButtonComponent {
  variant = input<'primary' | 'secondary' | 'ghost'>('primary');
  size = input<'large' | 'medium' | 'small'>('medium');
  type = input<'button' | 'submit'>('button');
  disabled = input(false);
  loading = input(false);
  width = input<number>();
  tabindex = input<number>();

  protected hostWidth = computed(() => {
    const w = this.width();
    return w !== undefined ? String(w) + 'px' : null;
  });
}
